import { render, staticRenderFns } from "./MediaPanel.vue?vue&type=template&id=10d9dbb4&scoped=true"
import script from "./MediaPanel.vue?vue&type=script&lang=ts&setup=true"
export * from "./MediaPanel.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./MediaPanel.vue?vue&type=style&index=0&id=10d9dbb4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d9dbb4",
  null
  
)

export default component.exports